// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: src/styles/LogistMobile.css */
.LM-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.LM-bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background: rgba(255,255,255,0.9);
  padding: 8px 0;
  box-shadow: 0 -2px 6px rgba(0,0,0,0.2);
  z-index: 1000;
}

.LM-btn {
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 16px;
}

.LM-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.LM-list, .LM-modal {
  background: #fff;
  width: 90%;
  max-height: 80%;
  overflow-y: auto;
  border-radius: 8px;
  padding: 16px;
}

.LM-list h3, .LM-modal h3 {
  margin-top: 0;
}

.LM-list ul, .LM-receipts {
  list-style: none;
  padding: 0;
  margin: 0;
}

.LM-list li {
  padding: 8px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}

.LM-list li.active {
  background: #007bff;
  color: #fff;
}

.LM-receipts li {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.status {
  padding: 2px 6px;
  border-radius: 4px;
  color: #fff;
}

.status-Открыта { background: #007bff; }
.status-Закрыта { background: #28a745; }
.status-Недоставлено,
.status-Не доставлено { background: #dc3545; }

.LM-close {
  margin-top: 12px;
  background: #dc3545;
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/modules/Logist/LogistMobilePage/LogistMobile.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,iCAAiC;EACjC,cAAc;EACd,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,mBAAmB,EAAE;AACvC;wBACwB,mBAAmB,EAAE;;AAE7C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* File: src/styles/LogistMobile.css */\r\n.LM-container {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.LM-bottom-bar {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  background: rgba(255,255,255,0.9);\r\n  padding: 8px 0;\r\n  box-shadow: 0 -2px 6px rgba(0,0,0,0.2);\r\n  z-index: 1000;\r\n}\r\n\r\n.LM-btn {\r\n  background: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 10px 16px;\r\n  font-size: 16px;\r\n}\r\n\r\n.LM-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.LM-list, .LM-modal {\r\n  background: #fff;\r\n  width: 90%;\r\n  max-height: 80%;\r\n  overflow-y: auto;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n}\r\n\r\n.LM-list h3, .LM-modal h3 {\r\n  margin-top: 0;\r\n}\r\n\r\n.LM-list ul, .LM-receipts {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.LM-list li {\r\n  padding: 8px;\r\n  border-bottom: 1px solid #ddd;\r\n  cursor: pointer;\r\n}\r\n\r\n.LM-list li.active {\r\n  background: #007bff;\r\n  color: #fff;\r\n}\r\n\r\n.LM-receipts li {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 8px 0;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.status {\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  color: #fff;\r\n}\r\n\r\n.status-Открыта { background: #007bff; }\r\n.status-Закрыта { background: #28a745; }\r\n.status-Недоставлено,\r\n.status-Не доставлено { background: #dc3545; }\r\n\r\n.LM-close {\r\n  margin-top: 12px;\r\n  background: #dc3545;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
